import * as React from 'react';

const Phone = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
        <path
            fill="#223260"
            fillRule="evenodd"
            d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0M9.008 6H6.656a.63.63 0 0 0-.464.192.63.63 0 0 0-.192.464q0 2.304.896 4.416a11.3 11.3 0 0 0 2.432 3.6 11.3 11.3 0 0 0 3.6 2.432Q15.04 18 17.344 18a.63.63 0 0 0 .464-.192.63.63 0 0 0 .184-.358l.008-.106v-2.352a.63.63 0 0 0-.192-.464.63.63 0 0 0-.464-.192q-1.312 0-2.368-.368a.55.55 0 0 0-.368-.032.6.6 0 0 0-.252.126l-.068.066-1.472 1.472a10.4 10.4 0 0 1-2.544-1.872 10.4 10.4 0 0 1-1.682-2.196l-.19-.348 1.472-1.472a.53.53 0 0 0 .176-.32.85.85 0 0 0-.016-.368q-.368-1.056-.368-2.368a.63.63 0 0 0-.192-.464.63.63 0 0 0-.358-.184z"
            clipRule="evenodd"
        />
    </svg>
);
export default Phone;
